/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCalculationRequestRequestDto } from '../../models/backend-calculation-request-request-dto';
import { BackendCalculationResultDto } from '../../models/backend-calculation-result-dto';

export interface MlDirectCalculationCreate$FormData$Params {
  body: BackendCalculationRequestRequestDto;
}

export function mlDirectCalculationCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MlDirectCalculationCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
  const rb = new RequestBuilder(rootUrl, mlDirectCalculationCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCalculationResultDto>;
    }),
  );
}

mlDirectCalculationCreate$FormData.PATH = '/api/ml/direct_calculation/';
